import { render, staticRenderFns } from "./StudentSubjectReportList.vue?vue&type=template&id=1aee1fbf&"
import script from "./StudentSubjectReportList.vue?vue&type=script&lang=ts&"
export * from "./StudentSubjectReportList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports